<template>
  <a-tooltip
    v-if="text"
    overlay-class-name="td-tooltip followup-tooltip"
  >
    <template slot="title">
      <h3 class="title">
        {{ $t('message["447"]') }}
      </h3>
      <p v-if="!text.followup_remind_time">
        {{ $t('message["1543"]') }}
      </p>
      <ul v-else>
        <li>
          <div class="top clearfix">
            <span class="time">{{ text.followup_remind_time }}</span>
          </div>
          <div class="content">
            {{ text.followup_remind_content }}
          </div>
        </li>
      </ul>
    </template>
    <!-- {{ text.followup_remind_time || '- -' }} -->
    <div
      v-if="text.followup_remind_time"
      class="date_time"
    >
      <p class="date">
        {{ text.followup_remind_time.split(' ') && text.followup_remind_time.split(' ')[0] }}
      </p>
      <p class="time fs-gray">
        {{ text.followup_remind_time.split(' ') && text.followup_remind_time.split(' ')[1] }}
      </p>
    </div>
  </a-tooltip>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    text: {
      type: Object,
      default: () => ({ })
    }
  },
  computed: {
    followup_lists () {
      return this.text.followup_lists
    }
  },
  methods: {
    moment
  }
}
</script>
<style lang="scss">
.followup-tooltip {
  width: 240px;
  .ant-tooltip-inner {
    max-height: 300px;
    overflow: auto;
    padding: 16px;
  }
  .title {
    margin-bottom: 16px;
  }
  li {
    margin-bottom: 16px;
  }
  .name {
    margin-right: 4px;
  }
  .content {
    color: $gray3;
  }
  .date_time {
    font-size: 12px;
    position: absolute;
    top: 8px;
    line-height: 18px;
  }
}
</style>
